<script setup>
    import { useAppState } from '../stores/app-state';

    const appState = useAppState();

</script>

<template>
    <div @click="appState.menuOpen = !appState.menuOpen" class="hamburger">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</template>